import React, {createContext} from 'react'

export const MyContext = createContext(); 

export const ProductProfileContext = createContext(); 

export const CheckoutListContext = createContext(); 

export const PageTemplateContext = React.createContext(); 